import React from 'react';
import { Typography, Paper, Grid, Box, Container } from '@mui/material';
import { Balance, Gavel, NotificationsActive, Info } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

// Gemeinsame Styles für die Kacheln
const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  p: 4,
  minHeight: 320,
  backgroundColor: '#fff',
  textDecoration: 'none',
  color: 'inherit',
  borderRadius: 1,
  boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.12)'
  }
};

const iconStyle = {
  fontSize: 48,
  color: '#2c3e50',
  mb: 3
};

const titleStyle = {
  fontSize: '1.5rem',
  fontWeight: 500,
  mb: 2,
  color: '#2c3e50'
};

const descriptionStyle = {
  color: '#666',
  fontSize: '0.95rem',
  lineHeight: 1.5,
  mt: 1
};

const Home = () => {
  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: 'calc(100vh - 200px)', width: '100%' }}>
      <Container maxWidth={false} sx={{ py: 6, px: 4 }}>
        <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
          <Typography 
            variant="h3" 
            component="h1" 
            align="center" 
            sx={{ 
              mb: 1,
              fontWeight: 500,
              color: '#2c3e50',
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Willkommen bei der Sozialgerichtsbarkeit
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            sx={{ 
              mb: 6,
              color: '#666',
              maxWidth: 900,
              mx: 'auto',
              lineHeight: 1.5,
              fontSize: '1.1rem',
              fontWeight: 400
            }}
          >
            Ihre zentrale Plattform für Entscheidungen und Informationen der deutschen Sozialgerichte
          </Typography>
          
          <Grid container spacing={4} alignItems="stretch">
            <Grid item xs={12} sm={6} lg={3}>
              <Paper
                component={RouterLink}
                to="/gerichte"
                sx={cardStyle}
              >
                <Balance sx={iconStyle} />
                <Typography sx={titleStyle}>
                  Gerichte
                </Typography>
                <Typography align="center" sx={descriptionStyle}>
                  Umfassendes Verzeichnis aller Sozialgerichte in Deutschland mit detaillierten Informationen.
                </Typography>
              </Paper>
            </Grid>
            
            <Grid item xs={12} sm={6} lg={3}>
              <Paper
                component={RouterLink}
                to="/entscheidungen"
                sx={cardStyle}
              >
                <Gavel sx={iconStyle} />
                <Typography sx={titleStyle}>
                  Entscheidungen
                </Typography>
                <Typography align="center" sx={descriptionStyle}>
                  Aktuelle Rechtsprechung und Entscheidungen der Sozialgerichte mit umfangreichen Suchmöglichkeiten.
                </Typography>
              </Paper>
            </Grid>
            
            <Grid item xs={12} sm={6} lg={3}>
              <Paper
                component={RouterLink}
                to="/mitteilungen"
                sx={cardStyle}
              >
                <NotificationsActive sx={iconStyle} />
                <Typography sx={titleStyle}>
                  Mitteilungen
                </Typography>
                <Typography align="center" sx={descriptionStyle}>
                  Aktuelle Mitteilungen, Bekanntmachungen und wichtige Informationen der Sozialgerichte.
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
              <Paper
                component={RouterLink}
                to="/impressum"
                sx={cardStyle}
              >
                <Info sx={iconStyle} />
                <Typography sx={titleStyle}>
                  Impressum
                </Typography>
                <Typography align="center" sx={descriptionStyle}>
                  Rechtliche Informationen, Kontaktmöglichkeiten und Datenschutzhinweise.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Home; 